import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import HistoryIcon from '@material-ui/icons/History';
import { InfoCard, Page, Header, Content } from '@backstage/core-components';
import { usePermission } from '@backstage/plugin-permission-react';
import { createPermission } from '@backstage/plugin-permission-common';
import { AuditLogTable } from './AuditLogTable';
export const backstageAuditReadPermission = createPermission({
  name: 'backstage.audit.read',
  attributes: { action: 'read' },
});
export function BackstageAuditPage() {
  const { allowed, loading } = usePermission({
    permission: backstageAuditReadPermission,
  });
  return (
    <Page themeId="tool">
      <Header title="Backstage audit logs" />
      <Content>
        {allowed ? (
          <InfoCard title="Audit log">
            <AuditLogTable />
          </InfoCard>
        ) : (
          <p>
            {loading ? 'Loading permissions?' : 'Audit log permission required'}
          </p>
        )}
      </Content>
    </Page>
  );
}
export const auditLogPlugin = createFrontendPlugin({
  pluginId: 'audit-log',
  extensions: [
    PageBlueprint.make({
      params: {
        path: '/audit-log',
        routeRef: createRouteRef(),
        title: 'Audit logs',
        icon: <HistoryIcon />,
        loader: async () => <BackstageAuditPage />,
      },
    }),
  ],
});
